import React from 'react';
import { Link } from 'react-router-dom';
import { Printer } from 'lucide-react';
import { MarketSectionView } from '../../components/market/MarketBlocks';
import { Glossary } from '../../components/market/MarketWidgets';
import { printWithDetails } from '../../components/market/MarketShell';
import { CopyLinkButton } from '../../components/guide/CopyLinkButton';
import { marketTopics, topicPath } from '../../data/market/topics';
import { MARKET_BASE_PATH, MARKET_SOURCE_LABEL } from '../../data/market/config';

/** Guía completa para jugadores en una sola página, lista para imprimir. Sin contenido administrativo. */
export function MarketFullGuide() {
  return <article className="space-y-10" data-id="element-3066" data-mp="167n7t4x15cne">
      <header className="space-y-3" data-id="element-3067" data-mp="11aoe2nha37pq">
        <p className="text-xs font-semibold text-[#D4AF37]" data-id="element-3068" data-mp="11bpqava16091">{MARKET_SOURCE_LABEL}</p>
        <h1 className="font-cinzel text-2xl font-bold text-white md:text-4xl" data-id="element-3069" data-mp="3825ok7im8px8">Vanguard Market · Guía completa para jugadores</h1>
        <p className="text-sm text-gray-400" data-id="element-3070" data-mp="334dzdl9cvhwq">Las capturas son demostraciones con datos ficticios. Los porcentajes de ejemplo no son tarifas vigentes.</p>
        <div className="flex flex-wrap gap-2 print:hidden" data-id="element-3071" data-mp="17vfu7wlkrugn">
          <button type="button" onClick={printWithDetails} className="inline-flex h-11 items-center gap-2 rounded-full bg-[#D4AF37] px-5 text-sm font-bold text-[#050b14] transition-colors duration-150 hover:bg-[#E3C158]" data-id="element-3072" data-mp="1cthbqd3crlq0">
            <Printer className="h-4 w-4" aria-hidden="true" data-id="element-3073" data-mp="1lmavampu179o" />
            Imprimir guía completa
          </button>
          <CopyLinkButton path={`${MARKET_BASE_PATH}/guia-completa`} data-id="element-3074" data-mp="1qjukuirzd6gx" />
          <Link to={MARKET_BASE_PATH} className="inline-flex h-11 items-center rounded-full border border-white/15 px-5 text-sm font-semibold text-gray-200 hover:text-white" data-id="element-3075" data-mp="1vk8j593s521r">
            Volver a la portada
          </Link>
        </div>
      </header>
      {marketTopics.map(t => <section key={t.key} aria-labelledby={`full-${t.key}`} className="space-y-6 border-t border-white/10 pt-8" data-id="element-3076" data-mp="650ykivcca2w">
          <div data-id="element-3077" data-mp="3u9h77wvz9hul">
            <h2 id={`full-${t.key}`} className="font-cinzel text-xl font-bold text-white md:text-2xl" data-id="element-3078" data-mp="3u8xncamrojdx">
              <Link to={topicPath(t)} className="hover:text-[#D4AF37]" data-id="element-3079" data-mp="3pbpdqyfopnoa">
                {t.title}
              </Link>
            </h2>
            <p className="mt-1 text-gray-400" data-id="element-3080" data-mp="83tv8gvmynuu">{t.summary}</p>
          </div>
          <div className="max-w-3xl space-y-8" data-id="element-3081" data-mp="32mrcswm68tg">
            {t.sections.map(s => <MarketSectionView key={s.id} section={{
          ...s,
          id: `${t.slug}-${s.id}`
        }} forceOpen data-id="element-3082" data-mp="h25n0m88nrov" />)}
            {t.widget === 'glossary' && <Glossary data-id="element-3083" data-mp="c21f3klec5a9" />}
          </div>
        </section>)}
    </article>;
}